import React, { useState, useRef, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import {
  IconPPT,
  IconDownload,
  IconReportIssue,
  MaximizeIcon,
} from "../../../icons/Icons";
import Header from "./Header";
import FileViewer from "react-file-viewer";
import file from "./Files/doc.docx";
// import docSlide1 from "../../../assets/images/docSlide1.svg";
// import docSlide2 from "../../../assets/images/docSlide2.svg";
import {
  generatePresignedUrl,
  bulkGeneratePresignedUrl,
} from "../../../api/common-store-api";
import { Link, useLocation, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { getGUID, getRemainingStringFileName } from "../../../common";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import Loader from "../../../components/Loader/Loader";

const Doc = ({
  actionReport,
  contentUrl,
  slideData,
  setContent,
  setIsFullScreenDoc,
  isFullScreenDoc,
}) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const userRole = useSelector(
    (state) => state.user.currentUser?.roles[0].name
  );
  const [contentUrlData, setContentUrlData] = useState(null);
  const [fileData, setFileData] = useState(null);
  const location = useLocation();
  const arrayDownloadableFiles = slideData?.downloadableFile;
  const [downloadableFileURLs, setDownloadableFileURLs] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const getPreviewUrl = async () => {
    console.log(contentUrl, "contentUrlDoc");
    const getGuid = getGUID(contentUrl);
    let previewUrl = await generatePresignedUrl(getGuid);
    if (previewUrl?.data) {
      setShowLoader(true);
      console.log(previewUrl?.data, "previewUrl.data Doc");
      setContentUrlData(previewUrl?.data);
      const response = await fetch(previewUrl?.data);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      // Get the file as array buffer
      const arrayBuffer = await response.arrayBuffer();

      // Convert to base64
      const base64 = btoa(
        new Uint8Array(arrayBuffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );

      // Create data URL
      const dataUrl = `data:application/pdf;base64,${base64}`;
      // console.log(dataUrl,"amigo am")
      setFileData(dataUrl);
      setShowLoader(false);
    }
  };

  useEffect(() => {
    getPreviewUrl();
    getBulkGeneratePresignedUrl();
  }, []);

  const getBulkGeneratePresignedUrl = async () => {
    if (
      arrayDownloadableFiles !== undefined &&
      arrayDownloadableFiles !== null &&
      arrayDownloadableFiles.length > 0
    ) {
      let responseURLsDownloadable = await bulkGeneratePresignedUrl(
        arrayDownloadableFiles.map((value) => value.filePath)
      );
      if (responseURLsDownloadable?.data) {
        setDownloadableFileURLs(responseURLsDownloadable?.data);
      }
    }
  };
  console.log(contentUrlData, "contentUrlData");

  const handleIsFullScreen = () => {
    setIsFullScreenDoc(true);
  };
  const handleCloseFullScreen = () => {
    setIsFullScreenDoc(false);
  };
  return (
    <div className="d-flex flex-grow-1 h-100 w-100">
      {showLoader ? (
        <div
          style={{
            height: "calc(100vh - 274px)",
            width: "100%",
          }}
        >
          <Loader type="activity" />
        </div>
      ) : (
        <div className="videoPreview docPreview w-100 flex-grow-1">
          <button
            className="position-absolute cursor-pointer"
            style={{ right: "16px", top: "16px", zIndex: 1 }}
            onClick={
              isFullScreenDoc ? handleCloseFullScreen : handleIsFullScreen
            }
          >
            {isFullScreenDoc ? (
              <svg
                width="31"
                height="31"
                viewBox="0 0 31 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  opacity="0.5"
                  x="0.0908203"
                  y="0.0909424"
                  width="30"
                  height="30"
                  rx="5.625"
                  fill="#232323"
                />
                <path
                  d="M8.925 22.125L7.875 21.075L10.2 18.75H8.25V17.25H12.75V21.75H11.25V19.8L8.925 22.125ZM21.075 22.125L18.75 19.8V21.75H17.25V17.25H21.75V18.75H19.8L22.125 21.075L21.075 22.125ZM8.25 12.75V11.25H10.2L7.875 8.925L8.925 7.875L11.25 10.2V8.25H12.75V12.75H8.25ZM17.25 12.75V8.25H18.75V10.2L21.075 7.875L22.125 8.925L19.8 11.25H21.75V12.75H17.25ZM15 16.5C14.5875 16.5 14.2344 16.3531 13.9406 16.0594C13.6469 15.7656 13.5 15.4125 13.5 15C13.5 14.5875 13.6469 14.2344 13.9406 13.9406C14.2344 13.6469 14.5875 13.5 15 13.5C15.4125 13.5 15.7656 13.6469 16.0594 13.9406C16.3531 14.2344 16.5 14.5875 16.5 15C16.5 15.4125 16.3531 15.7656 16.0594 16.0594C15.7656 16.3531 15.4125 16.5 15 16.5Z"
                  fill="white"
                />
              </svg>
            ) : (
              <MaximizeIcon />
            )}
          </button>
          {contentUrlData && fileData ? (
            <>
              {contentUrl.split(".").pop().toLowerCase() === "doc" ||
              contentUrl.split(".").pop().toLowerCase() === "docx" ? (
                <DocViewer
                  documents={[
                    {
                      uri: contentUrlData,
                      fileType: contentUrl.split(".").pop(),
                      fileName: getRemainingStringFileName(contentUrl),
                    },
                  ]}
                  pluginRenderers={DocViewerRenderers}
                  style={{ width: "100%", height: "100%", zoom: "117%" }}
                  onError={(e) => console.log("Error Documents:", e)}
                />
              ) : (
                <FileViewer
                  fileType={contentUrl.split(".").pop()}
                  filePath={fileData}
                  style={{ width: "100%", height: "600" }}
                  // errorComponent={CustomErrorComponent}
                  // onError={this.onError}
                  errorComponent={<div>Error loading file</div>}
                  onError={(e) => console.log("Error Documents:", e)}
                />
              )}
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default Doc;
